import React,{useRef} from 'react'
import PropTypes from 'prop-types'

function PageSlider (props) {
  const { children, step,className } = props
  const offset = step * - window.innerHeight
  const sliderRef = useRef(null)
  return (
    <div ref={sliderRef} className={`of-page-slider${className?' '+className:''}`} style={{ top: `${offset}px` }}>{children}</div>
  )
}

PageSlider.propTypes = {
  children: PropTypes.any,
  step: PropTypes.number,
  className: PropTypes.any
}

export default PageSlider
